module.exports = __webpack_public_path__ + "static/media/21ECLAC27.1770e3e1.jpg";